// imports section Start
import React from "react";
import {
  Box,
  CardMedia,
  Typography,
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import no_image from "../../assets/images/no_image.png";
import AddIcon from "@mui/icons-material/Add";
// imports section End

export default function GuestItemList({ addToCart, cartItem, BASEURL }) {
  // Hooks start
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";

  // Handlers start
  const handleAddToCart = () => {
    addToCart(cartItem);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "LKR",
    }).format(price);
  };
  // Handlers end

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: 1,

        boxShadow: 2,
        backgroundColor: theme.palette.background.paper,
        padding: 2,
        margin: "8px 0",
        color: theme.palette.text.primary,
        flexWrap: { xs: "wrap", sm: "nowrap" }, // Stack items if screen is too small
      }}
    >
      {/* Image Section */}
      <CardMedia
        component="img"
        image={
          cartItem.WEBIMAGEPATH
            ? `${BASEURL}${cartItem.WEBIMAGEPATH.replace("~", "")}`
            : no_image
        }
        alt={cartItem.MENUNAME || "Product Image"}
        sx={{
          width: { xs: 80, sm: 100 }, // Smaller image on small screens
          height: { xs: 80, sm: 100 },
          borderRadius: 2,
          objectFit: "cover",
          marginRight: 2,
        }}
      />

      {/* Content Section */}
      <Grid container spacing={2} sx={{ flex: 1 }}>
        <Grid
          item
          xs={8}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          minWidth={0} // Prevent overflow
        >
          <Typography variant="item_card_title" noWrap>
            {cartItem?.MENUNAME || "No Name"}
          </Typography>

          <Typography
            variant="item_card_price"
            sx={{
              color: theme.palette.text.secondary,
              marginTop: 1,
            }}
          >
            {formatPrice(cartItem.RATE)}
          </Typography>
        </Grid>

        <Grid
          item
          xs={4}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <IconButton
            onClick={handleAddToCart}
            sx={{
              boxShadow: 2,
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.text.buttontxt,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
              width: { xs: 36, sm: 48 }, // Smaller button on small screens
              height: { xs: 36, sm: 48 },
            }}
          >
            <AddIcon sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }} />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
}
